import { useServerConfig } from "@hooks/useServerConfig";
import { standardizeDomain } from "@utils/misc";
import { DomainSecurityBadge as DomainSecurityBadgeConfig, PropsWithClassName, cn } from "kz-ui-sdk";
import { useEffect, useState } from "react";

interface DomainSecurityBadgeProps extends PropsWithClassName {}

/**
 * Display domain security badge
 * Based on server config, display the badge if the current domain matches
 * Open link in new tab if redirectUrl is provided, unless use imageUrl instead
 */
const DomainSecurityBadge = ({ className }: DomainSecurityBadgeProps) => {
  const [badgeConfig, setBadgeConfig] = useState<DomainSecurityBadgeConfig | null>(null);
  const { data: serverConfig } = useServerConfig();

  useEffect(() => {
    // validate domain security config
    if (serverConfig?.domainSecurity?.enabled) {
      const badgeConfigList = serverConfig?.domainSecurity?.badges ?? [];
      const currentDomain = standardizeDomain(window.location.hostname);
      const badgeConfig = badgeConfigList.find((badge) => {
        if (!badge.domain) return false;
        const badgeDomain = standardizeDomain(badge.domain);
        return badgeDomain === currentDomain;
      });
      if (badgeConfig && badgeConfig.imageUrl) {
        setBadgeConfig(badgeConfig);
      }
    }
  }, [serverConfig]);

  if (!badgeConfig) return null;

  return (
    <a
      className={cn("h-full w-auto animate-fade-in overflow-hidden", className)}
      href={badgeConfig.redirectUrl ?? badgeConfig.imageUrl}
      target={badgeConfig.redirectType === "redirect" ? undefined : "_blank"}
      rel="noopener noreferrer"
    >
      <img
        src={badgeConfig.imageUrl}
        alt="security badge"
        className="h-full w-auto"
      />
    </a>
  );
};

export default DomainSecurityBadge;
